import { createI18n } from 'vue-i18n'
import en from './en'
import { resolveInitialLocale } from './locale'
import nb from './nb'

// The instance is born with the visitor's resolved locale (saved choice →
// browser language → nb; the marketing host skips the browser step and
// defaults to nb, see ./locale.ts) so the very first paint is already in the final
// language — never 'nb' first with a switch after mount, and module-scope
// code that reads the global locale at import time sees the real value.
// Unit tests pin the locale to 'nb' in vitest.setup.ts / browser.setup.ts,
// which keeps them deterministic regardless of the environment's
// navigator.language.
const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: 'nb',
  messages: { nb, en },
})

export default i18n
